import type { PropsWithChildren, ReactElement } from 'react';

import styled, { useTheme, keyframes } from 'styled-components';

export type LoadingAreaProps = PropsWithChildren<{
  /**
   * Состояние загрузки
   */
  loading?: boolean;
}>;

const rotateAnimation = keyframes({
  from: {
    transform: 'rotate(0deg)',
  },
  to: {
    transform: 'rotate(360deg)',
  },
});

const StyledWrapper = styled.div<{
  $loading: boolean;
}>(({ $loading }) => ({
  position: 'relative',
  minHeight: $loading ? 200 : undefined,
}));

export const StyledContent = styled.div<{
  $loading: boolean;
}>(({ $loading }) => ({
  transition: 'opacity 0.15s',
  opacity: $loading ? 0.3 : 1,
}));

// animation in object syntax not working
export const StyledLoader = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  color: ${({ theme: { colors, loadingArea } }) => colors[loadingArea.COLOR]};
  text-align: center;
  pointer-events: none;
  transform: translate(-50%, -50%);

  & svg {
    animation-name: ${rotateAnimation};
    animation-timing-function: ${({ theme: { loadingArea } }) => loadingArea.ANIMATION};
    animation-duration: 1s;
    animation-iteration-count: infinite;
  }
`;

export function LoadingArea({
  loading = true,
  children = undefined,
}: LoadingAreaProps): ReactElement {
  const { loadingArea } = useTheme();

  return (
    <StyledWrapper $loading={loading}>
      <StyledContent $loading={loading}>{children}</StyledContent>

      {loading && <StyledLoader>{loadingArea.ICON}</StyledLoader>}
    </StyledWrapper>
  );
}
